import { api } from "./client";
import type { User, Environment, Plan } from "./types";

export interface MeResponse {
  user: User;
  environment: Environment;
  plan: Plan;
}

export const authApi = {
  signup: (email: string, password: string, account_name: string) =>
    api<MeResponse>("/api/dashboard/signup", { method: "POST", body: { email, password, account_name } }),
  login: (email: string, password: string) =>
    api<MeResponse>("/api/dashboard/login", { method: "POST", body: { email, password } }),
  logout: () => api<void>("/api/dashboard/logout", { method: "POST" }),
  me: (signal?: AbortSignal) => api<MeResponse>("/api/dashboard/me", { signal }),
  changePassword: (current: string, next: string) =>
    api<void>("/api/dashboard/change-password", { method: "POST", body: { current, next } }),
  resendVerification: () =>
    api<{ ok: boolean }>("/api/dashboard/verify-email/resend", { method: "POST" }),
  verifyEmail: (token: string) =>
    api<{ ok: boolean; verified: boolean }>("/api/dashboard/verify-email", { query: { token } }),
  resetPassword: (token: string, newPassword: string) =>
    api<{ ok: boolean }>("/api/dashboard/reset-password", { method: "POST", body: { token, newPassword } }),
};
